import { AppState } from 'src/store';
import { createSelector } from 'reselect';
import { get } from 'lodash';
import {
  projectState,
  StateSelection,
  createFilteredViewDefnsSelector,
} from 'src/components/ListGridPair/ListGridPair.selectors';
import { STYLE_COLOR_NAME } from 'src/utils/Domain/Constants';
import { getDataFromCache, isDataLoaded } from 'src/services/pivotServiceCache';
import { AdornmentType } from 'configuration-schemas/viewdefns/literals';
import type { HistoryGridOwnProps } from 'configuration-schemas/ownProps';

const getRawViewDefns = (state: AppState) => state.pages.hindsighting.historyGrid.listView.viewDefns;
const getFilteredViewDefns = createFilteredViewDefnsSelector(getRawViewDefns);

function selectState(state: AppState, ownProps: HistoryGridOwnProps): StateSelection {
  const { title, defns, showFlowStatus } = ownProps;
  const { listView: viewState } = state.pages.hindsighting.historyGrid;

  const { viewDataState, isConfigLoading } = viewState;
  const viewDefns = getFilteredViewDefns(state);
  const treeData = getDataFromCache(viewState)?.tree || [];
  const configLoaded = !viewState.isConfigLoading;
  const dataLoaded = isDataLoaded(viewDataState);
  const adornments: AdornmentType[] = get(viewState.viewDefns.grid, 'adornments', []);

  return {
    identityField: ownProps.keys?.idProp || STYLE_COLOR_NAME,
    subheaderState: state.subheader,
    configLoaded,
    dataLoaded,
    treeData,
    title,
    subheaderViewDefns: defns.subheader,
    shouldFilterFlowStatus: false,
    activeTab: state.perspective.activeTab,
    viewDefns,
    isConfigLoading,
    viewDataState,
    adornments,
    allowWorklistFunctionality: false,
    showFlowStatus,
    isCompanionCollapsed: state.uiPose.isCompanionCollapsed,
    subheaderErrorText: ownProps.subheaderErrorText,
  };
}

export const selectData = createSelector(selectState, projectState);
